import React from 'react';
import { IconProps } from '../types';
const MinecraftGlowInkSac: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="10" y="3" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(145, 104, 95, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(189, 140, 129, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(145, 104, 95, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(145, 104, 95, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(21, 115, 116, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(47, 151, 153, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(21, 115, 116, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(128, 255, 192, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(47, 151, 153, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(18, 109, 110, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(21, 115, 116, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(50, 161, 161, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(18, 109, 110, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(75, 222, 186, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(21, 115, 116, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(47, 151, 153, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(128, 255, 192, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(75, 222, 186, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(21, 115, 116, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(23, 80, 80, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(75, 222, 186, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(58, 181, 178, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(25, 49, 49, 255)" />
</svg>);
export default MinecraftGlowInkSac;